import axios      from 'axios'
import { config } from '@/config';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const locale = urlParams.get('lg')

export class SaleSquezeSdkBrowser {

  clientKey = config.clientKey;

  viewToken: string | undefined;

  editToken: string | undefined;

  apiBaseUrl = '/api/v3';

  language = locale;


  constructor() {
    console.log(`%c======== SaleSqueze SDK initialized ========
Language : ${ this.language }
Client   : ${ this.clientKey }
API      : ${ this.apiBaseUrl }
============================================`, this.clientKey ? 'color:green' : 'color:red')
  }

  /**
   * @param {string} documentServiceType
   * @return {Promise<any>}
   */
  createDocument(documentServiceType: string, document: any) {
    return axios.post(`${ this.apiBaseUrl }/dynamic-form/${ documentServiceType }/documents`, document, {
      headers: {
        'Client-Key': this.clientKey,
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': this.editToken,
      }
    })
  }
  /**
   * @param {string[]} tags Tags to filter by.
   * @return {Promise<any>}
   */
  getProducts(filter: { tags?: string[], categories?: string[], key?: string }, project?: { [x: string]: number }) {
    return axios.get(`${this.apiBaseUrl}/catalog/product/cpq/documents`, {
      headers: {
        'Client-Key': this.clientKey,
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': this.editToken,
        'Accept-Language': this.language,
        'X-Accept-Language': this.language
      },
      params: {
        pageSize: 999,
        sortBy: {
          path: '_createdAt',
          direction: -1
        },
        filter: {
          ...(filter.tags ? {
            tags: {
              type: 'type-string',
              value: filter.tags,
              options: {
                exactMatch: true,
                exclude: false,
              }
            }
          } : {}),
          ...(filter.categories ? {
            categoryKey: {
              type: 'type-string',
              value: filter.categories,
              options: {
                exactMatch: true,
                exclude: false,
              }
            }
          } : {}),
          ...(filter.key ? {
            key: {
              type: 'type-string',
              value: filter.key,
              options: {
                exactMatch: true,
                exclude: false,
              }
            }
          } : {}),
        },
        project: {
          media: 1,
          ...project
        }
      }
    })
  }

  getDataTable(key){
    return axios.get(`${this.apiBaseUrl}/system/data-table/cpq/documents/${key}`, {
      headers: {
        'Client-Key': this.clientKey,
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': this.editToken,
        'Accept-Language': this.language,
        'X-Accept-Language': this.language,
      }
    })
  }
}

export const salesqueze = new SaleSquezeSdkBrowser()
